import React from "react";
import { Grid } from "@material-ui/core";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import CachedIcon from "@material-ui/icons/Cached";

const RegularForm = ({ classes, intl, username, handleSetUserName, password, handleSetPassword, loading }) => {
  const ButtonIcon = ({ className, loading }) => {
    if (!loading) {
      return null;
    }

    return <CachedIcon className={className} />;
  };

  return (
    <Grid container direction={"column"} spacing={2}>
      <Grid item container direction={"column"}>
        <Grid item xs={12}>
          <label htmlFor="username" className={clsx(classes.etiqueta, "etiquetaEmailNifTelefono")}>
            {intl.formatMessage({ id: "ra.auth.agent_credential" })}
          </label>
        </Grid>
        <Grid item xs={10}>
          <input
            className={classes.input}
            name="username"
            id="username"
            type="text"
            value={username}
            onChange={(e) => handleSetUserName(e.target.value)}
          />
        </Grid>
      </Grid>
      <Grid item container direction={"column"}>
        <Grid item>
          <label htmlFor="password" className={clsx(classes.etiqueta, "etiquetaPassword")}>
            {intl.formatMessage({ id: "ra.auth.password" })}
          </label>
        </Grid>
        <Grid item>
          <input
            className={classes.input}
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => handleSetPassword(e.target.value)}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            type="submit"
            className={classes.loginButton}
            disabled={!password || !username}
            startIcon={<ButtonIcon loading={loading} className={classes.spin} />}
          >
            {intl.formatMessage({ id: "ra.auth.entrar" })}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RegularForm;
